import { MainLayoutPage } from 'LayoutPages';
import { getCMSAssets, getFrontendUrl } from 'helpers/Uri';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState, useRef, useContext } from 'react';
import {
    Accordion,
    AccordionContext,
    Button,
    Card,
    Col,
    Row,
    useAccordionButton,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { GlobalMenu } from 'scene/Layout/GlobalMenu';
import { classNames } from 'primereact/utils';
import { addLocale } from 'primereact/api';
import { isNil } from 'lodash';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Calendar } from 'primereact/calendar';
import ReSchedulePanel from './ReSchedulePanel';
import IsNumberVerification from 'components/IsNumberVerification';
import { fontFamily, fontSize } from 'Styles';
import moment from 'moment';
import * as rdEnum from 'helpers/enum';
import * as testDriveModel from 'model/ITestDrive';
import { ICodeName } from 'model/ICommon';
import * as testDriveService from 'services/TestDrive';
import * as testDriveHelper from 'businessHelpers/TestDriveHelper';
import { Page } from '../../../Page';

import { IAppState } from 'model/IAppState';
import { ISubmitMessage } from 'model/ICommon';
import { useCountryState } from 'helpers/useCountryState';
import { useFieldArray } from 'react-hook-form';
import PrivacyPolicyLink from 'components/PrivacyPolicyLink';
import { Dialog } from 'primereact/dialog';
import { useCheckMobileScreen } from 'helpers/useCheckMobileScreen';
import PrivacyCollectionDialog from 'pages/Main/checkout/PrivacyCollectionDialog';
import { useParams } from 'react-router-dom';
import { checkIsShowScrollBar } from 'stores/ScrollBarDisplay';
import { Footer } from 'scene/Layout/Footer';
import SaveDialog from '../../Main/checkout/SaveDialog';

type AccordionOpenType = {
    btn0: boolean;
    btn1: boolean;
    btn2: boolean;
    btn3: boolean;
    btn4: boolean;
};



const TestDrive = () => {
    const { QRcode, webkey } = useParams();
   
    const dispatch = useDispatch();
    const [disabledDates, setDisabledDates] = useState<Date[]>([]);

    const [locations, setLocations] = useState<
        testDriveModel.ITestDriveLocation[]
    >([]);   

    const [models, setModels] = useState<testDriveModel.ITestDriveModel[]>([]);   
   

    const [variants, setVariants] = useState<testDriveModel.TestDriveVariant[]>(
        [],
    );    

    const [accordionOpen, setAccordionOpen] = useState<AccordionOpenType>({
        btn0: false,
        btn1: false,
        btn2: false,
        btn3: false,
        btn4: false,
    });

    const [formValues, setFormValues] = useState<any>({
        selectedLocation: { value: testDriveHelper.getInitLocation() },
        selectedModel: { value: testDriveHelper.getInitModel() },
        selectedVarient: { value: testDriveHelper.getInitVariant() },
    })

    const [isRestoring, setIsRestoring] = useState(false);
    const [restoreValues, setRestoreValues] = useState<Record<string, any>>({});
    const [rescheduleValues, setRescheduleValues] = useState<Record<string, any>>({});

    const [selectedDate, setSelectedDate] = useState<string>('');
    const [minSelectStartDate, setMinSelectStartDate] = useState<any>(null);
    const [maxSelectEndDate, setMaxSelectEndDate] = useState<any>(null);
    const [selectedTime, setSelectedTime] = useState<any>(null);

    const [timeslotOptions, setTimeslotOptions] = useState<string[]>([]);
    const [whatExpected, setWhatExpected] = useState<string[]>([]);

    

    const [pageState, setPageState] = useState<testDriveModel.ITestDrive>(
        testDriveHelper.getInitTestDrive(),
    );
    const [invalidPageState, setInvalidPageState] =
        useState<testDriveModel.IInvalidTestDrive>(
            testDriveHelper.getInitInvalidTestDrive(),
        );
    const [submitMessage, setSubmitMessage] = useState<ISubmitMessage>();

    const [isOpen, setIsOpen] = useState(false);
    const [submittingStatus, setSubmittingStatus] = useState(
        rdEnum.enumProcessingStatus.Init,
    );
    const [timeLoadingStatus, setTimeLoadingStatus] = useState(
        rdEnum.enumProcessingStatus.Init,
    );

    const handleDialogOpen = () => {
        setIsOpen(true);
        cleanStatesAfterBooking();
    };

    const handleDialogHide = () => {
        setIsOpen(false);
    };

    const isMobile = useCheckMobileScreen();

    const selectedDeliveryFromStore = useSelector((state: IAppState) => {
        return state.selectedDelivery;
    });

    const sessionFromStore = useSelector((state: IAppState) => {
        return state.session;
    });

    const isScrollbarVisible = useSelector((state: IAppState) => {
        return state.isShowScrollBar.isShowScrollBar;
    });

    const updateFieldValue = (field: any, value: any) => {
        setFormValues((prev: any) => {
            const newFormValues = { ...prev };
            newFormValues[field] = value;
            return newFormValues
        })
    }

    const InvalidInputID = {
        invalidLocation: 'drp-location',
        invalidModel: 'drp-model',
        invalidVariant: 'drp-variant',
        invalidDate: 'startDate',
        invalidTime: 'div-timeslot',
        invalidFirstname: 'firstname',
        invalidLastname: 'lastname',
        invalidEmail: 'email',
        invalidMobile: 'phone',
        invalidPostcode: 'postcode',
        invalidCustomerType: 'div-customer-type',
        invalidPrivacyStatement: 'cb-ack-agreement',
    };
    const customOrder = [
        'invalidLocation',
        'invalidModel',
        'invalidVariant',
        'invalidDate',
        'invalidTime',
        'invalidFirstname',
        'invalidLastname',
        'invalidEmail',
        'invalidMobile',
        'invalidPostcode',
        'invalidCustomerType',
        'invalidPrivacyStatement',
    ] as const;

    const doGetLocations = async () => {
        let country = selectedDeliveryFromStore.Country?.code || '';
        let response = await testDriveService.getTestDriveLocations(country);
        if (response.status) {
            let tempLocations: testDriveModel.ITestDriveLocation[] =
                convertLocationDataToObject(response.data);
                setLocations(tempLocations);
        } else {
            setLocations([]);
        }
    };

    const doGetModels = async () => {
      
        let response = await testDriveService.getTestDriveModels(
            formValues.selectedLocation,
        );
        if (response.status) {
            let responseData = response.data;
            let tempModels: testDriveModel.ITestDriveModel[] = [];
            if (!isNil(responseData) && responseData.length > 0) {
                responseData.map((item: any) => {
                    tempModels.push({
                        ModelID: item.modelID,
                        Model: item.model,
                    });
                });
            }
            setModels(tempModels);

            if (isRestoring && restoreValues.model) {
                updateFieldValue("selectedModel", restoreValues.model)
            } else {
                //auto select model
                if (tempModels.length > 0) {
                    setFormValues({
                        ...formValues, selectedModel: {
                            ModelID: tempModels[0].ModelID,
                            Model: tempModels[0].Model,
                        }
                    })

                }
            }
        }
    };


    const doGetVariants = async (
        location: testDriveModel.ITestDriveLocation | null,
        model: testDriveModel.ITestDriveModel | null,

    ) => {
       
        if (location == null || model == null) return;
        let response = await testDriveService.getTestDriveVariants(
            location,
            model,
        );
        if (response.status) {
            let responseData = response.data;

            let tempVariant: testDriveModel.TestDriveVariant[] = [];
            if (!isNil(responseData) && responseData.length > 0) {
                responseData.map((item: any) => {
                    tempVariant.push({
                        ModelID: item.modelID,
                        VariantID: item.variantID,
                        Variant: item.variantName,
                    });
                });
            }
            setVariants(tempVariant);

            if (isRestoring && restoreValues.variant) {
                updateFieldValue("selectedVariant", restoreValues.variant);
            }
            
        }
    };

    const doGetAvailableDate = async (defaultSelectedDate: Date | null) => {

        let minDate;
        let maxDate;
        
        let response = await testDriveService.getTestDriveAvailableDates(
            formValues.selectedLocation,
            formValues.selectedModel,
            formValues.selectedVariant,
        );

        if (response.status) {
            minDate = moment(response.data?.minDate).toDate();
            maxDate = moment(response.data?.maxDate).toDate();
            setMinSelectStartDate(minDate);
            setMaxSelectEndDate(maxDate);

            if (Array.isArray(response.data?.disabledDates)) {
                const disabledDatesConverted = response.data.disabledDates.map(
                    (dateString: string) => {
                        return moment(dateString, 'YYYY/MM/DD').toDate();
                    },
                );

                setDisabledDates(disabledDatesConverted);
            }

            //do not select previous selected date
            //if (isRestoring && restoreValues.date) {
            //    setSelectedDate(
            //        moment(restoreValues.date).format('YYYY-MM-DD'),
            //    );
            //} else {
                setSelectedDate(moment(minDate).format('YYYY-MM-DD'));
            //}

            setInvalidPageState((prev) => {
                return {
                    ...prev,
                    invalidDate: false,
                    invalidTime: null,
                }
            });

           
        }
    };

    const doGetAvailableTimeslot = async (defaultSelectTime: string | null) => {
       
        setTimeLoadingStatus(rdEnum.enumProcessingStatus.Processing);
        let response = await testDriveService.getTestDriveAvailableTime(
            formValues.selectedLocation,
            formValues.selectedModel,
            formValues.selectedVariant,
            selectedDate,
        );
        setTimeLoadingStatus(rdEnum.enumProcessingStatus.Processed);
        if (response.status) {
            let timeList = response.data.timeList;
            //console.log(timeList);
            //const formattedStoredTime = moment(restoreValues.date as any).format(
            //    'YYYY-MM-DD',
            //)

            //if (formattedStoredTime === selectedDate) {
            //    const existingTimes = response.data.timeList;
            //    const missingTime = restoreValues.selectedTime;

            //    const exists = existingTimes.includes(missingTime);
            //    if (!exists) {
            //        console.log("Adding missing time:", missingTime);

            //        // Add the missing time
            //        existingTimes.push(missingTime);

            //        // Sort the list properly by time
            //        existingTimes.sort((a: string, b: string) =>
            //            moment(a, 'hh:mm A').diff(moment(b, 'hh:mm A'))
            //        );
            //    }

            //    setTimeslotOptions(existingTimes);
            //}
            //console.log(timeList);
            setTimeslotOptions(timeList);
            //if (restoreValues.selectedTime) {
            //    setSelectedTime(restoreValues.selectedTime)
            //}

            if (isRestoring) {
                //setRestoreValues({})
                setIsRestoring(false);
            }


            setWhatExpected(response.data.whatExpectedList);
        }
    };


    //method here for dealing with url values
    const doGetTestDriveData = async () => {
       
        let country = selectedDeliveryFromStore.Country?.code || '';

        try {

            const [testDriveResponse, locationResponse] = await Promise.all([
                testDriveService.getTestDrive(webkey),
                testDriveService.getTestDriveLocations(country),
            ]);
     
            if (locationResponse.status) {
                let tempLocations: testDriveModel.ITestDriveLocation[] =
                    convertLocationDataToObject(locationResponse.data);
                setLocations(tempLocations);
            } else {
                setLocations([]);
            }

            if (!testDriveResponse.status) {
                throw new Error("TestDrive booking not found or expired");
            }

            if (testDriveResponse.status) {

                let responeData = testDriveResponse.data;
                //console.log("stored data", responeData);
                let tempSelectedLocation: testDriveModel.ITestDriveLocation = {
                    Country: responeData.country,
                    LocationID: responeData.testDriveLocationID,
                    Name: responeData.testDriveLocationName,
                    Address: responeData.testDriveLocation,
                };
                let tempSelectedNodel: testDriveModel.ITestDriveModel = {
                    ModelID: responeData.yanaModelID,
                    Model: responeData.model,
                };
                let tempSelectedVariant: testDriveModel.TestDriveVariant = {
                    ModelID: responeData.yanaModelID,
                    VariantID: responeData.yanaVariantID,
                    Variant: responeData.variantName,
                };

                let tempData: testDriveModel.ITestDrive = {
                    yanaCustomerID: responeData.yanaCustomerId,
                    yanaCustomerNo: responeData.yanaCustomerNumber,
                    firstname: responeData.firstName,
                    lastname: responeData.lastName,
                    email: responeData.email,
                    mobile: responeData.phone,
                    postcode: responeData.postcode,
                    customerType: responeData.customerType,
                    utmtag: responeData.utmtag,
                    location: tempSelectedLocation,
                    model: tempSelectedNodel,
                    variant: tempSelectedVariant,
                    date: moment(responeData.yanaFormatDate, 'DD.MM.YYYY').toDate(),
                    formatDate: responeData.yanaFormatDate, //dd.MM.yyyy
                    selectedTime: responeData.time,
                    currentVehicle: responeData.currentVehicle,
                    privacyStatement: responeData.privacyStatement,
                    marketing: responeData.marketing,
                    transaction: responeData.transaction,
                    yanaTestDriveID: responeData.yanaTestDriveID,
                    yanaTestDriveNo: responeData.yanaTestDriveNo,
                    testDriveLink: null,
                    webkey: webkey,
                };


                setRescheduleValues({
                    webkey,
                    yanaTestDriveID: responeData.yanaTestDriveID,
                    yanaTestDriveNo: responeData.yanaTestDriveNo
                })

                setRestoreValues(tempData);

                setPageState(
                    {
                        ...pageState,
                        firstname: tempData.firstname,
                        lastname: tempData.lastname,
                        email: tempData.email,
                        mobile: tempData.mobile,
                        postcode: tempData.postcode,
                        transaction: responeData.transaction,
                        yanaTestDriveID: responeData.yanaTestDriveID,
                        yanaTestDriveNo: responeData.yanaTestDriveNo,
                        customerType: responeData.customerType,
                        currentVehicle: responeData.currentVehicle,
                        privacyStatement: responeData.privacyStatement,
                        marketing: responeData.marketing,
                        utmtag: responeData.utmtag,

                    }
                )



                updateFieldValue("selectedLocation", tempSelectedLocation)

            }
           
         
        } catch (error) {
            console.error("Failed to fetch test drive session", error);

            // ✅ You could show a toast or error component here instead if preferred
            // Show user-friendly message before redirecting
            //alert("Sorry, this test drive link has expired or is invalid.");

            // Redirect to homepage or booking landing
          
        }
    };

    const convertLocationDataToObject = (
        data: any,
    ): testDriveModel.ITestDriveLocation[] => {
        let tempLocations: testDriveModel.ITestDriveLocation[] = [];
        if (!isNil(data) && data.length > 0) {
            data.map((item: any) => {
                tempLocations.push({
                    Country: item.country,
                    LocationID: item.testDriveLocationID,
                    Name: item.name,
                    Address: item.address,
                });
            });
        }
        return tempLocations;
    };

    const cleanStatesAfterBooking = () => {
        updateFieldValue("selectedLocation", testDriveHelper.getInitLocation())
        setRestoreValues({})
        setRescheduleValues({})
        setIsRestoring(false);

    };

 

    useEffect(() => {
        if (!isScrollbarVisible) {
            dispatch(checkIsShowScrollBar(true));
        }
    }, []);


    //linear form flow dictated by useEffect hooks.

    useEffect(() => {
        if (!isNil(webkey) && webkey !== '') {
            setIsRestoring(true);
            doGetTestDriveData();
        } else {
            console.log('do get locations')
            doGetLocations();
        }
    }, [webkey]);

    useEffect(() => {
        if (!isRestoring) setModels([]);
        if (!isRestoring) updateFieldValue("selectedModel", testDriveHelper.getInitModel())

        if (formValues.selectedLocation && formValues.selectedLocation.LocationID !== '') {
            doGetModels();

            setInvalidPageState((prev) => {
                return {
                    ...prev,
                    invalidLocation: false
                }
            });

        }
    }, [formValues.selectedLocation?.LocationID]);


    useEffect(() => {

        if (!isRestoring) setVariants([]);
        if (!isRestoring) updateFieldValue("selectedVariant", testDriveHelper.getInitVariant())

        if (!formValues.selectedLocation || !formValues.selectedModel) return;
        if (formValues.selectedLocation?.ModelID === '') return;
        if (formValues.selectedModel?.ModelID === '') return;

        setInvalidPageState((prev) => {
            return {
                ...prev,
                invalidModel: false
            }
        });
        
        doGetVariants(
            formValues.selectedLocation || null,
            formValues.selectedModel || null,
        );         

    }, [formValues.selectedModel?.ModelID]);


    useEffect(() => {

        if (!isRestoring) {
            setDisabledDates([]);
            setSelectedDate('');
            setMinSelectStartDate(null);
            setMaxSelectEndDate(null);
            setSelectedTime(null);
        }
       

        if (formValues.selectedVariant && formValues.selectedVariant?.VariantID !== '') {

            setInvalidPageState((prev) => {
                return {
                    ...prev,
                    invalidVariant: false
                }
            });

            setInvalidPageState((prev) => {
                return {
                    ...prev,
                    invalidVarient: false
                }
            });

            doGetAvailableDate(null);
        }
    }, [formValues.selectedVariant?.VariantID]);

    useEffect(() => {
        setWhatExpected([]);
        setTimeslotOptions([])
        setSelectedTime(null)
       
        if (selectedDate !== '') {
            doGetAvailableTimeslot(null)
        }
    }, [
        selectedDate,
    ]);

    useEffect(() => {


    },[selectedTime])

    //clear invalid fl
    const onLocationChange = (e: any) => {
        updateFieldValue("selectedLocation", e.value);
    };

    const onModelChange = (e: any) => {
        updateFieldValue("selectedModel", e.value);
    };

    const onVariantChange = (e: any) => {
        updateFieldValue("selectedVariant", e.value);
    };

    const isNumberKey = (e: any) => {
        IsNumberVerification(e);
    };

    const validation = () => {
        if (isNil(pageState)) return;
        let invalid = false;

        let invalidFirstName = false;
        if (isNil(pageState.firstname) || pageState.firstname == '') {
            invalidFirstName = true;
            invalid = true;
        }

        let invalidLastName = false;
        if (isNil(pageState.lastname) || pageState.lastname == '') {
            invalidLastName = true;
            invalid = true;
        }

        let invalidEmail = false;
        if (isNil(pageState.email) || pageState.email == '') {
            invalidEmail = true;
            invalid = true;
        } else {
        }

        let invalidMobile = false;
        if (isNil(pageState.mobile) || pageState.mobile == '') {
            invalidMobile = true;
            invalid = true;
        }

        //let invalidCountry = false;
        //if (isNil(selectedCountry?.code) || selectedCountry?.code == "") {
        //    invalidCountry = true;
        //    invalid = true;
        //}

        let invalidLocation = false;
        if (isNil(formValues.selectedLocation?.Name) || formValues.selectedLocation?.Name == '') {
            invalidLocation = true;
            invalid = true;
        }

        let invalidModel = false;
        if (isNil(formValues.selectedModel?.ModelID) || formValues.selectedModel?.ModelID == '') {
            invalidModel = true;
            invalid = true;
        }

        let invalidVariant = false;
        if (
            isNil(formValues.selectedVariant?.VariantID) ||
            formValues.selectedVariant?.VariantID === ''
        ) {
            invalidVariant = true;
            invalid = true;
        }

        let invalidDate = false;

        if (isNil(selectedDate) || selectedDate === '') {
            invalidDate = true;
            invalid = true;
        }

        let invalidTime = false;
        if (isNil(selectedTime) || selectedTime == '') {
            invalidTime = true;
            invalid = true;
        }

        let invalidPrivacyStatement = false;
        if (!pageState?.privacyStatement) {
            invalidPrivacyStatement = true;
            invalid = true;
        }

        let invalidPostcode = false;
        if (pageState?.postcode.length < 4) {
            invalidPostcode = true;
            invalid = true;
        }

        let invalidCustomerType = false;
        if (isNil(pageState?.customerType) || pageState?.customerType == '') {
            invalidCustomerType = true;
            invalid = true;
        }

        let updateInvalid: testDriveModel.IInvalidTestDrive = {
            ...invalidPageState,
            invalidLocation: invalidLocation,
            invalidModel: invalidModel,
            invalidVariant: invalidVariant,
            invalidDate: invalidDate,
            invalidTime: invalidTime,
            invalidFirstname: invalidFirstName,
            invalidLastname: invalidLastName,
            invalidEmail: invalidEmail,
            invalidMobile: invalidMobile,
            invalidPostcode: invalidPostcode,
            invalidPrivacyStatement: invalidPrivacyStatement,
            invalidCustomerType: invalidCustomerType,
        };

        setInvalidPageState(updateInvalid);

        if (invalid) {
            for (const key of customOrder) {
                const value = updateInvalid[key];
                if (!isNil(value) && value) {
                    const eleID = InvalidInputID[key];
                    if (eleID) {
                        console.log(eleID);
                        scrollToErrorEle(eleID);
                        return invalid;
                    }
                }
            }
        }

        //console.log(invalid);
        return invalid;
    };

    const scrollToErrorEle = (eleID: string) => {
        const element = document.getElementById(eleID);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
    };

    const onBookTestDrive = async () => {
        if (isNil(pageState)) return;

        setSubmitMessage({ Status: null, Message: null });
        let requestData: testDriveModel.ITestDrive = {
            ...pageState,
            selectedTime: selectedTime,
            transaction: rdEnum.enumTestDriveTransaction.Book,
            yanaCustomerID: sessionFromStore?.YanaCustomerID || '',
            yanaCustomerNo: sessionFromStore?.YanaCustomerNo || '',
            //country: selectedCountry,
            location: formValues.selectedLocation,
            model: formValues.selectedModel,
            variant: formValues.selectedVariant,
            date: moment(selectedDate).toDate(),
            formatDate: moment(selectedDate).format('DD.MM.YYYY'),
            utmtag: QRcode,
            testDriveLink: window.location.href,
        };
        if (validation()) return;


        if (rescheduleValues.webkey) {
           
            requestData.yanaTestDriveID = rescheduleValues.yanaTestDriveID
            requestData.yanaTestDriveNo = rescheduleValues.yanaTestDriveNo
            requestData.webkey = rescheduleValues.webkey

            console.log('mod the request with keys', requestData)
        }

        console.log("request appointment", requestData)

        setSubmittingStatus(rdEnum.enumProcessingStatus.Processing);
        let response = await testDriveService.saveTestDrive(requestData);
        setSubmittingStatus(rdEnum.enumProcessingStatus.Processed);



        if (response.status) {
            setSubmitMessage({
                Status: response.status,
                Message: 'Submit successfully.',
            });

            let responseData = response.data;

            requestData = {
                ...requestData,
                //  yanaTestDriveID: responseData.yanaTestDriveID,
                //   yanaTestDriveNo: responseData.yanaTestDriveNo
            };
            setPageState(requestData);
            handleDialogOpen();
        } else {
            setSubmitMessage({
                Status: response.status,
                Message: response.message,
            });
        }
    };

    useEffect(() => {
        if (window.digitalData) {
            window.digitalData = {
                pageInfo: { pageName: '' },
                internalCampaignInfo: {},
                articleInfo: {},
                visitorProfile: {},
                vehicleInfo: {},
                toolsInfo: {},
            };
        }
    }, []);

    const handleCustomerType = (type: any) => {
        setPageState({
            ...pageState,
            customerType: type,
        });
       
        setInvalidPageState((prev) => {
            return {
                ...prev,
                invalidCustomerType: false,
            }
        });
    };

    const FrqQuestionsToggle = ({
        children,
        eventKey,
        callback,
        isOpen,
    }: any) => {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(eventKey, () => {
            if (callback) {
                callback(eventKey); // Invoke the callback if provided
            }
            setAccordionOpen({
                ...accordionOpen,
                [`btn${eventKey}` as keyof AccordionOpenType]:
                    !accordionOpen[`btn${eventKey}` as keyof AccordionOpenType],
            });
        });

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <button
                type="button"
                onClick={decoratedOnClick}
                className="question-accordion-header-btn"
                aria-expanded={
                    accordionOpen[`btn${eventKey}` as keyof AccordionOpenType]
                }
            >
                <span>{children}</span>
                {accordionOpen[`btn${eventKey}` as keyof AccordionOpenType] ? (
                    <img alt="" src={`${getCMSAssets()}/users/minus.svg`} />
                ) : (
                    <img alt="" src={`${getCMSAssets()}/users/plus.svg`} />
                )}
            </button>
        );
    };

    addLocale('custom', {
        firstDayOfWeek: 1, // Set Monday as the first day
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
        ],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ],
        today: 'Today',
        clear: 'Clear',
    });


    const isDisable = (): boolean => {

        if (!isNil(webkey) && webkey !== "") {
            return true;
        }
        return false;
    }

    return (
        <MainLayoutPage sceneId="container-has-header">
            <div className="global-options-container">
                <GlobalMenu activeBtn="test" />
                <div className="test-drive-container">
                    <div className="test-drive-title-box">
                        <div className="test-drive-title">
                            <h1>TEST DRIVE</h1>
                        </div>
                        <div className="test-drive-subtitle">
                            <p>Please complete the information</p>
                            <p>below to book a test drive.</p>
                            <br />
                        </div>
                    </div>

                    <div className="test-drive-img">
                        {!isMobile ? (
                            <img
                                className="image"
                                src={`${getCMSAssets()}/testDrive/test-drive-main-theme.png`}
                            />
                        ) : (
                            <img
                                className="image"
                                src={`${getCMSAssets()}/testDrive/test-drive-main-theme-mobile.png`}
                            />
                        )}
                    </div>

                    <div className="test-dirve-selection-container">
                       

                        <Row className="location-container">
                            <Col lg={4} className="left-panel">
                                <h6>Where would you like to test drive?</h6>
                            </Col>

                            <Col lg={8} className="dropdown-panel">
                                <Dropdown
                                    value={formValues.selectedLocation}
                                    options={locations}
                                    onChange={(e: any) => {
                                        onLocationChange(e);
                                        setIsRestoring(false); 
                                    }}
                                    className="global-location-dropdown"
                                    optionLabel="Name"
                                    emptyMessage="Please select a location"
                                    placeholder=""
                                    inputId="drp-location"
                                />
                                <label
                                    className={
                                        formValues.selectedLocation.Name
                                            ? 'location-option-label selected'
                                            : 'location-option-label'
                                    }
                                >
                                    Select location
                                </label>
                                {invalidPageState?.invalidLocation && (
                                    <div
                                        id="location-help"
                                        className="p-error block text-left"
                                    >
                                        Require location
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <Row className="model-trim-container">
                            <Col lg={4} className="left-panel">
                                <h6>What vehicle are you interested in?</h6>
                            </Col>
                            <Col lg={8} className="model-trim-panel">
                                <Dropdown
                                    value={formValues.selectedModel}
                                    options={models}
                                    onChange={(e: any) => {
                                        onModelChange(e);
                                        setIsRestoring(false); 
                                    }}
                                    className="global-location-dropdown"
                                    optionLabel="Model"
                                    placeholder="Select model"
                                    emptyMessage="Loading..."
                                    style={{
                                        fontFamily:
                                            'CadillacGothic-NarrowRegular',
                                        color: 'gray',
                                    }}
                                    inputId="drp-model"
                                />
                                {invalidPageState?.invalidModel && (
                                    <div
                                        id="model-help"
                                        className="p-error block text-left"
                                    >
                                        Require Model
                                    </div>
                                )}
                                <Dropdown
                                    value={formValues.selectedVariant}
                                    options={variants}
                                    onChange={(e: any) => {
                                        onVariantChange(e);
                                        setIsRestoring(false); 
                                    }}
                                    className="global-location-dropdown"
                                    optionLabel="Variant"
                                    placeholder="Select trim"
                                    emptyMessage="Loading..."
                                    style={{
                                        fontFamily:
                                            'CadillacGothic-NarrowRegular',
                                        color: 'gray',
                                    }}
                                    inputId="drp-variant"
                                />
                                {invalidPageState?.invalidVariant && (
                                    <div
                                        id="model-help"
                                        className="p-error block text-left"
                                    >
                                        Require Trim
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <Row className="schedule-calendar-container">
                            <Col lg={12}>
                                <h6>When would you like to test drive?</h6>
                            </Col>
                            <Col lg={6} className="left-panel">
                                <Calendar
                                    inline
                                    id="startDate"
                                    dateFormat="yy-mm-dd"
                                    showIcon={true}
                                    value={moment(selectedDate).toDate()}
                                    minDate={moment(
                                        minSelectStartDate,
                                    ).toDate()}
                                    maxDate={moment(maxSelectEndDate).toDate()}
                                    disabledDates={disabledDates}
                                    locale="custom"
                                    onChange={(e: any) => {
                                        setSelectedDate(
                                            moment(e.value as any).format(
                                                'YYYY-MM-DD',
                                            ),
                                        );
                                    }}
                                ></Calendar>
                            </Col>
                            <Col lg={6} className="timeslot-panel">
                                <div
                                    className="timeslot-upper-container"
                                    id="div-timeslot"
                                >
                                    <div className="timeslot-date">
                                        {/*{console.log(selectedDate)}*/}
                                        {!isNil(selectedDate) &&
                                            selectedDate !== '' && selectedDate !== 'Invalid date' && (
                                                <h6>
                                                    {moment(
                                                        selectedDate,
                                                    ).format(
                                                        'dddd, DD MMMM YYYY',
                                                    )}
                                                </h6>
                                            )}
                                    </div>
                                    <div className="timeslot-options-panel">
                                        {timeLoadingStatus ===
                                        rdEnum.enumProcessingStatus
                                            .Processing ? (
                                            <>
                                                <ProgressSpinner
                                                    style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        paddingTop: '10%',
                                                    }}
                                                    strokeWidth="5"
                                                    animationDuration=".8s"
                                                    className={'black-spinner'}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                {timeslotOptions?.map(
                                                    (
                                                        item: string,
                                                        index: any,
                                                    ) => {
                                                        return (
                                                            <div
                                                                className={
                                                                    selectedTime !=
                                                                    item
                                                                        ? 'timeslot-item'
                                                                        : 'timeslot-item selected'
                                                                }
                                                                key={
                                                                    item + index
                                                                }
                                                                onClick={() => {
                                                                    setSelectedTime( item );
                                                                }}
                                                            >
                                                                <span>
                                                                    {item}
                                                                </span>
                                                            </div>
                                                        );
                                                    },
                                                )}
                                            </>
                                        )}
                                    </div>
                                    {invalidPageState?.invalidTime && (
                                        <small
                                            id="time-help"
                                            className="p-error block"
                                        >
                                            Require Time
                                        </small>
                                    )}
                                </div>
                                <div className="timeslot-bottom-container">
                                    <div className="services-provided-panel">
                                        {timeLoadingStatus !==
                                            rdEnum.enumProcessingStatus
                                                .Processing &&
                                            !isNil(whatExpected) &&
                                            whatExpected.map(
                                                (
                                                    item: string,
                                                    index: number,
                                                ) => {
                                                    return (
                                                        <div
                                                            className="services-item"
                                                            key={
                                                                'whatexpected_' +
                                                                index
                                                            }
                                                        >
                                                            <img
                                                                className="image"
                                                                src={`${getCMSAssets()}/testDrive/tick-circle.svg`}
                                                            />
                                                            <span>{item}</span>
                                                        </div>
                                                    );
                                                },
                                            )}
                                    </div>
                                    <div className="need-scheduling-panel">
                                        <h6>Need support?</h6>
                                        <div className="email-panel">
                                            <SaveDialog origin={'testdrive'} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="personal-info-container">
                            <Col lg={4} className="left-panel">
                                <h6>How can we contact you?</h6>
                            </Col>
                            <Col lg={8}>
                                <Row className="">
                                    <Col lg={6} className="input-container">
                                        <div className="input-item">
                                            <span className="wrapper-box">
                                                <InputText
                                                    id="firstname"
                                                    aria-describedby="firstname-help"
                                                    className={classNames({
                                                        'p-invalid':
                                                            invalidPageState?.invalidFirstname,
                                                    })}
                                                    placeholder=" "
                                                    value={pageState?.firstname}
                                                    onChange={(e) => {
                                                        //if (isNil(pageState)) return;
                                                        setPageState({
                                                            ...pageState,
                                                            firstname: e.target.value,
                                                        });

                                                        setInvalidPageState((prev) => {
                                                            return {
                                                                ...prev,
                                                                invalidFirstname: isNil(e.target.value) || e.target.value == ""
                                                            }
                                                        });
                                                    }}
                                                    disabled={isDisable()}
                                                />
                                                <label>First Name *</label>
                                            </span>
                                        </div>
                                        {invalidPageState?.invalidFirstname && (
                                            <small
                                                id="fristname-help"
                                                className="p-error block"
                                            >
                                                Require Valid First Name
                                            </small>
                                        )}
                                    </Col>
                                    <Col lg={6} className="input-container">
                                        <div className="input-item">
                                            <span className="wrapper-box">
                                                <InputText
                                                    id="lastname"
                                                    aria-describedby="lastname-help"
                                                    className={classNames({'p-invalid': invalidPageState?.invalidLastname})}
                                                    placeholder=" "
                                                    value={pageState?.lastname}
                                                    onChange={(e) => {
                                                        setPageState({
                                                            ...pageState,
                                                            lastname: e.target.value,
                                                        });
                                                       
                                                        setInvalidPageState((prev) => {
                                                            return {
                                                                ...prev,
                                                                invalidLastname: isNil(e.target.value) || e.target.value == ""
                                                            }
                                                        });
                                                    }}
                                                    disabled={isDisable()}
                                                />
                                                <label>Last Name *</label>
                                            </span>
                                        </div>
                                        {invalidPageState?.invalidLastname && (
                                            <small
                                                id="lastname-help"
                                                className="p-error block"
                                            >
                                                Require Valid Last Name
                                            </small>
                                        )}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={12} className="input-container">
                                        <div className="input-item">
                                            <span className="wrapper-box">
                                                <InputText
                                                    id="email"
                                                    aria-describedby="email-help"
                                                    className={classNames({
                                                        'p-invalid':
                                                            invalidPageState?.invalidEmail,
                                                    })}
                                                    placeholder=" "
                                                    value={pageState?.email}
                                                    onChange={(e) => {
                                                        setPageState({
                                                            ...pageState,
                                                            email: e.target.value,
                                                        });

                                                        setInvalidPageState((prev) => {
                                                            return {
                                                                ...prev,
                                                                invalidEmail: isNil(e.target.value) || e.target.value == ""
                                                            }
                                                        });
                                                    }}
                                                    disabled={isDisable()}
                                                />
                                                <label>Email *</label>
                                            </span>
                                        </div>
                                        {invalidPageState?.invalidEmail && (
                                            <small
                                                id="email-help"
                                                className="p-error block"
                                            >
                                                Require Valid Email
                                            </small>
                                        )}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={12} className="input-container">
                                        {/*onKeyPress={(e: any) => isNumberKey(e)}*/}
                                        <div className="input-item">
                                            <span className="wrapper-box">
                                                <InputText
                                                    id="phone"
                                                    aria-describedby="phone-help"
                                                    className={classNames({
                                                        'p-invalid':
                                                            invalidPageState?.invalidMobile,
                                                    })}
                                                    placeholder=" "
                                                    value={
                                                        pageState?.mobile || ''
                                                    }
                                                    onKeyPress={(e: any) =>
                                                        isNumberKey(e)
                                                    }
                                                    onInput={(event: any) => {
                                                        let phone = event.target.value.slice(0,11);
                                                        setPageState({
                                                            ...pageState,
                                                            mobile: phone,
                                                        });
                                                        setInvalidPageState((prev) => {
                                                            return {
                                                                ...prev,
                                                                invalidMobile: isNil(event.target.value) || event.target.value == ""
                                                            }
                                                        });
                                                    }}
                                                    disabled={isDisable()}
                                                />
                                                <label>Phone Number *</label>
                                            </span>
                                        </div>
                                        {invalidPageState?.invalidMobile && (
                                            <small
                                                id="lastname-help"
                                                className="p-error block"
                                            >
                                                Require Valid Phone Number
                                            </small>
                                        )}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col
                                        lg={12}
                                        className="input-container one-line"
                                    >
                                        <div className="input-item">
                                            <span className="wrapper-box">
                                                <InputText
                                                    id="postcode"
                                                    aria-describedby="postcode-help"
                                                    className={classNames({
                                                        'p-invalid':
                                                            invalidPageState?.invalidPostcode,
                                                    })}
                                                    placeholder=" "
                                                    value={pageState?.postcode}
                                                    onKeyPress={(e: any) =>
                                                        isNumberKey(e)
                                                    }
                                                    onInput={(event: any) => {
                                                        let postcode = event.target.value.slice(0,4);
                                                        setPageState({
                                                            ...pageState,
                                                            postcode: postcode,
                                                        });
                                                        setInvalidPageState({
                                                            ...invalidPageState,
                                                            invalidPostcode: isNil(postcode) || postcode == ""
                                                        });
                                                    }}
                                                    disabled={isDisable()}
                                                />
                                                <label>Postcode *</label>
                                            </span>
                                        </div>
                                        {invalidPageState?.invalidPostcode && (
                                            <small
                                                id="postcode-help"
                                                className="p-error block"
                                            >
                                                Require Valid Postcode
                                            </small>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className="business-identity-container">
                            <Col lg={4} className="left-panel">
                                <h6>
                                    Are you interested in purchasing for
                                    yourself or a business?
                                </h6>
                            </Col>
                            <Col lg={8} className="optional-panel">
                                <div className="input-container one-line">
                                    <div className="customer-type-selection">
                                        <div
                                            className="variant-btn-panel"
                                            id="div-customer-type"
                                        >
                                            <Button
                                                className={
                                                    pageState?.customerType ==
                                                    rdEnum.enumClientTypes
                                                        .Private.Code
                                                        ? 'stat-button-link variant-btn selected'
                                                        : 'stat-button-link variant-btn'
                                                }
                                                data-dtm="checkout"
                                                onClick={() => {
                                                    if (!isDisable()) {
                                                        handleCustomerType(
                                                            rdEnum.enumClientTypes
                                                                .Private.Code,
                                                        );
                                                    }
                        
                                                }}
                                                disabled={isDisable()}
                                            >
                                                <img
                                                    className="image"
                                                    src={`${getCMSAssets()}/testDrive/user.svg`}
                                                />
                                                <span>Private</span>
                                            </Button>
                                            <Button
                                                className={
                                                    pageState?.customerType ==
                                                    rdEnum.enumClientTypes
                                                        .Business.Code
                                                        ? 'stat-button-link variant-btn selected'
                                                        : 'stat-button-link variant-btn'
                                                }
                                                data-dtm="checkout"
                                                onClick={() => {
                                                    if (!isDisable()) {
                                                        handleCustomerType(
                                                            rdEnum.enumClientTypes
                                                                .Business.Code,
                                                        );
                                                    }
                                                }}
                                                disabled={isDisable()}
                                            >
                                                <img
                                                    className="image"
                                                    src={`${getCMSAssets()}/testDrive/briefcase.svg`}
                                                />
                                                <span>Business</span>
                                            </Button>
                                        </div>
                                        {invalidPageState?.invalidCustomerType && (
                                            <small
                                                id="customer-type-help"
                                                className="p-error block"
                                            >
                                                Require Customer Type
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="current-vehicle-container">
                            <Col lg={4} className="left-panel">
                                <div className="optional-title">Optional</div>
                                <h6>What vehicle are you currently driving?</h6>
                            </Col>
                            <Col lg={8} className="optional-panel">
                                <div className="input-container one-line">
                                    <div className="input-item">
                                        <span className="wrapper-box">
                                            <InputText
                                                id="currentVehicle"
                                                aria-describedby="currentVehicle-help"
                                                placeholder=" "
                                                value={
                                                    pageState?.currentVehicle
                                                }
                                                onChange={(e) => {
                                                    //if (isNil(pageState)) return;
                                                    setPageState({
                                                        ...pageState,
                                                        currentVehicle:
                                                            e.target.value,
                                                    });
                                                }}
                                                disabled={isDisable()}
                                            />
                                            <label>
                                                Current Vehicle (optional)
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="checkbox-privacy-container">
                            <div className="checkbox-container">
                                <div className="checkbox-item">
                                    <div className="checkbox-content">
                                        <Checkbox
                                            name="cb-ack-agreement"
                                            inputId="cb-ack-agreement"
                                            onChange={(e) => {
                                                //if (isNil(pageState)) return;
                                                setPageState({
                                                    ...pageState,
                                                    privacyStatement: e.checked,
                                                });
                                                setInvalidPageState({
                                                    ...invalidPageState,
                                                    invalidPrivacyStatement:
                                                        !e.checked,
                                                });
                                            }}
                                            checked={
                                                pageState?.privacyStatement
                                            }
                                        ></Checkbox>
                                        <label
                                            htmlFor="cb-ack-agreement"
                                            className="p-checkbox-label"
                                        >
                                            By registering my interest in a test
                                            drive, I agree to Cadillac's{' '}
                                            <PrivacyPolicyLink props="Privacy Policy" />{' '}
                                            and <PrivacyCollectionDialog />.
                                        </label>
                                    </div>
                                    {invalidPageState?.invalidPrivacyStatement && (
                                        <small
                                            id="lastname-help"
                                            className="p-error block"
                                        >
                                            Please review and agree to
                                            Cadillac's Privacy policy to proceed
                                        </small>
                                    )}
                                </div>

                                <div className="checkbox-item">
                                    <div className="checkbox-content">
                                        <Checkbox
                                            name="cb-ack-test-drive-optional"
                                            inputId="cb-ack-test-drive-optional"
                                            onChange={(e) => {
                                                //if (isNil(pageState)) return;
                                                setPageState({
                                                    ...pageState,
                                                    marketing: e.checked,
                                                });
                                            }}
                                            checked={pageState?.marketing}
                                        ></Checkbox>
                                        <label
                                            htmlFor="cb-ack-test-drive-optional"
                                            className="p-checkbox-label"
                                        >
                                            I consent to receiving direct
                                            marketing materials from Cadillac.
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="variant-btn-panel book-test-drive">
                            {submittingStatus ==
                            rdEnum.enumProcessingStatus.Processing ? (
                                <Button
                                    type="button"
                                    className="progress-btn"
                                    disabled={true}
                                >
                                    <ProgressSpinner
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                        }}
                                        strokeWidth="5"
                                        animationDuration=".8s"
                                        className={'white-spinner'}
                                    />
                                </Button>
                            ) : (
                                <React.Fragment>
                                    <Button
                                        className="variant-btn"
                                        disabled={
                                            !pageState?.privacyStatement ||
                                            false
                                        }
                                        style={{
                                            border: 'none',
                                            background:
                                                !pageState?.privacyStatement ||
                                                false
                                                    ? '#CCCCCC'
                                                    : '#282828',
                                        }}
                                        onClick={() => {
                                            onBookTestDrive();
                                        }}
                                    >
                                        <h6
                                            style={{
                                                color:
                                                    !pageState?.privacyStatement ||
                                                    false
                                                        ? '#707070'
                                                        : '#fff',
                                            }}
                                        >
                                            BOOK YOUR TEST DRIVE
                                        </h6>
                                    </Button>
                                    {/*{!isNil(submitMessage) && (*/}
                                    {/*    <div className={classNames({*/}
                                    {/*        "text-success": submitMessage.Status,*/}
                                    {/*        "text-error": !submitMessage.Status*/}
                                    {/*    })}>{submitMessage?.Message}</div>*/}
                                    {/*)}*/}
                                </React.Fragment>
                            )}
                        </div>

                        <div className="test-drive-faqs-container">
                            <h1 className="test-drive-faqs-title">FAQs</h1>
                            <Accordion
                                className="questions-accordion"
                                alwaysOpen
                            >
                                {rdEnum.enumTestDriveFAQs?.map(
                                    (faqItem: any, index: any) => {
                                        return (
                                            <Card key={faqItem + index}>
                                                <Card.Header>
                                                    <FrqQuestionsToggle
                                                        eventKey={index}
                                                    >
                                                        {faqItem?.title}
                                                    </FrqQuestionsToggle>
                                                </Card.Header>
                                                <Accordion.Collapse
                                                    eventKey={index}
                                                >
                                                    <Card.Body>
                                                        {faqItem?.context}
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        );
                                    },
                                )}
                            </Accordion>
                        </div>
                    </div>

                    <Footer pageName="testDrive" />
                </div>
            </div>

            <Dialog
                className="test-drive-success-dialog"
                visible={isOpen}
                onHide={() => handleDialogHide()}
                draggable={false}
                resizable={true}
            >
                <div className="test-drive-success-container">
                    <div className="successful-details-panel">
                        <div className="successful-details-title">
                            <h1>BOOKING CONFIRMED</h1>
                            {/* <p>You will receive a confirmation email shortly, and a member of our Cadillac Concierge team will be in touch.</p> */}
                            <p>
                                We&rsquo;ve sent you a confirmation email, and
                                look forward to welcoming you
                            </p>
                        </div>
                        <div className="successful-details-content">
                            {/*<div className='booking-item'>*/}
                            {/*    <div className='item-name'>Test Drive ID</div>*/}
                            {/*    <div className='item-value'>{pageState?.yanaTestDriveNo}</div>*/}
                            {/*</div>*/}

                            <div className="booking-item">
                                <div className="item-name">Model & Trim</div>
                                <div className="item-value">
                                    {pageState?.model.Model}{' '}
                                    {pageState?.variant.Variant}
                                </div>
                            </div>

                            <div className="booking-item">
                                <div className="item-name">
                                    Test Drive Location
                                </div>
                                <div className="item-value">
                                    {pageState?.location?.Name}
                                </div>
                            </div>

                            <div className="booking-item">
                                <div className="item-name">First Name</div>
                                <div className="item-value">
                                    {pageState?.firstname}
                                </div>
                            </div>

                            <div className="booking-item">
                                <div className="item-name">Last Name</div>
                                <div className="item-value">
                                    {pageState?.lastname}
                                </div>
                            </div>

                            <div className="booking-item">
                                <div className="item-name">Email Address</div>
                                <div className="item-value">
                                    {pageState?.email}
                                </div>
                            </div>

                            <div className="booking-item last-item">
                                <div className="item-name">Phone Number</div>
                                <div className="item-value">
                                    {pageState?.mobile}
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isMobile ? (
                        <div className="successful-img-panel">
                            <img
                                className="image"
                                src={`${getCMSAssets()}/testDrive/test-drive-success.png`}
                            />
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="cross-box" onClick={() => handleDialogHide()}>
                    <img
                        alt=""
                        className="close-icon"
                        src={`${getCMSAssets()}/main/cross.svg`}
                    />
                </div>
            </Dialog>
        </MainLayoutPage>
    );
};

export default TestDrive;
